import React from 'react';

const COLORS = [
  { label: 'Blue', value: '#3B82F6' },
  { label: 'Red', value: '#EF4444' },
  { label: 'Green', value: '#15803D' },
  { label: 'Pink', value: '#EC4899' },
  { label: 'White', value: '#FFFFFF' },
  { label: 'Gray', value: '#9CA3AF' }
];

export default function HLineToolbar({ line, isAdmin, onUpdate, onDelete, onClose, onShare }) {
  if (!line) return null;

  const readOnly = line.isShared && !isAdmin;

  return (
    <div className="hline-toolbar">
      {readOnly ? (
        <div className="hline-tb-readonly-badge" title="Only Admin can modify shared lines">
          <i className="bi bi-shield-lock"></i> Shared by Admin
        </div>
      ) : (
        <>
          <div className="hline-tb-drag-handle">
            <i className="bi bi-grip-vertical"></i>
          </div>
          
          <div className="hline-tb-colors">
            {COLORS.map(c => (
              <button
                key={c.value}
                type="button"
                className={`hline-color-btn ${line.color === c.value ? 'active' : ''}`}
                style={{ backgroundColor: c.value }}
                onClick={(e) => {
                  e.stopPropagation();
                  onUpdate({ ...line, color: c.value });
                }}
                title={c.label}
              />
            ))}
          </div>

          <div className="hline-tb-sep" />

          <button
            type="button"
            className={`hline-tb-btn ${line.style === 'solid' ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onUpdate({ ...line, style: 'solid' });
            }}
            title="Solid Line"
          >
            <i className="bi bi-dash-lg"></i>
          </button>

          <button
            type="button"
            className={`hline-tb-btn ${line.style === 'dashed' ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onUpdate({ ...line, style: 'dashed' });
            }}
            title="Dashed Line"
          >
            <i className="bi bi-three-dots"></i>
          </button>

          <div className="hline-tb-sep" />

          <input
            type="text"
            className="hline-tb-input"
            placeholder="Label (e.g., Resistance)"
            value={line.label || ''}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => onUpdate({ ...line, label: e.target.value })}
          />

          {isAdmin && !line.isShared && (
            <>
              <div className="hline-tb-sep" />
              <button
                type="button"
                className="hline-tb-btn"
                style={{ color: 'var(--brand-primary)' }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (onShare) onShare(line.id);
                }}
                title="Share this line with all users"
              >
                <i className="bi bi-share-fill"></i>
              </button>
            </>
          )}

          <div className="hline-tb-sep" />

          <button
            type="button"
            className="hline-tb-btn text-red"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(line.id);
            }}
            title="Delete Line (Del)"
          >
            <i className="bi bi-trash3"></i>
          </button>
        </>
      )}
      
      {readOnly && <div className="hline-tb-sep" />}
      <button
        type="button"
        className="hline-tb-btn"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        title="Close"
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
  );
}
